import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=33b54cc4&scoped=true"
import script from "./LanguageButton.vue?vue&type=script&lang=js"
export * from "./LanguageButton.vue?vue&type=script&lang=js"
import style0 from "./LanguageButton.vue?vue&type=style&index=0&id=33b54cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b54cc4",
  null
  
)

export default component.exports